import { SUPER_ADMIN_API_ENDPOINTS, SUPER_ADMIN_API_URL } from "../../../constants";
import { User } from "../../../pages/login/login.model";
import superAdminAxiosInstance from "../../../core/apiService/superAdminApiService";
import axios from "axios";
// import { StorageService } from "../../../core/storageService/storageService";

//Login user
const superAdminAuthService = async (userData: User): Promise<any> => {
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.AUTH_LOGIN}`, userData);
  return response.data;
};

//Logout user
// const superAdminLogout = (): void => {
//   localStorage.removeItem("user");
//   localStorage.removeItem("reg_code");
// };

//login recover service - for forgot password
const superAdminLoginRecoverService = async (userData: User): Promise<any> => {
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.RECOVER_LOGIN}`, userData);
  return response.data;
};

//forgot username service
const superAdminForgotUsernameService = async (userData: User): Promise<any> => {
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.FORGOT_USERNAME}`, userData);
  return response.data;
};

//reset password service
const superAdminResetPasswordService = async (userData: User): Promise<any> => {
  const response = await superAdminAxiosInstance.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.RESET_PASSWORD}`, userData);
  return response.data;
};


const superAdminLogout = async (token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.LOGOUT}`, {}, config);
  return response.data;
};


const superAdminRefreshToken = async (token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.get(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.REFRESH_TOKEN}`, config);
  return response.data;
};

//to get privacy policy
const superAdminGetPrivacyPolicy = async (): Promise<any> => {
  const response = await superAdminAxiosInstance.get(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.GET_PRIVACY_POLICY}`);
  return response.data;
};

//to get terms and conditons
const superAdminGetTermsCondition = async (): Promise<any> => {
  const response = await superAdminAxiosInstance.get(`${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.SUPER_ADMIN_AUTH.GET_TERMS_CONDTIONS}`);
  return response.data;
};

const superAdminLoginService = {
    superAdminAuthService,
    superAdminLogout,
    superAdminLoginRecoverService,
    superAdminForgotUsernameService,
    superAdminResetPasswordService,
    superAdminRefreshToken,
    superAdminGetPrivacyPolicy,
    superAdminGetTermsCondition
  };
  
export default superAdminLoginService;